import axios from "../axios-interceptor.js"
import { errorResponse, successResponse } from "./SpaceServices.js";

let tenantId = localStorage.getItem("tenantId")
const BACKEND_API = process.env.REACT_APP_BACKEND_API;
const AI_BUILDER_API = process.env.REACT_APP_AI_FORM_BUILDER;

export const upsertWorkflowAI = async (prompt, workflow, context = {}) => {
    let responseObj = { data: null, status: '', message: '' };
    try {
        const body = { prompt };
        if (workflow) body.workflow = workflow;
        if (Array.isArray(context.spaceUsers)) body.spaceUsers = context.spaceUsers;
        if (Array.isArray(context.spaceGroups)) body.spaceGroups = context.spaceGroups;
        if (Array.isArray(context.spaceUserPickers)) body.spaceUserPickers = context.spaceUserPickers;
        let response = await axios({
            method: "POST",
            url: `${AI_BUILDER_API}/api/workflows/upsert`,
            data: body,
            headers: {
                tenantId: localStorage.getItem("tenantId"),
            },
        });
        responseObj.status = response.status;
        responseObj.data = response.data?.data ?? null;
        responseObj.message = response.data?.message;
    } catch (error) {
        responseObj.status = error?.response?.status || 500;
        responseObj.message = error?.response?.data?.message || error?.message || 'Failed to generate workflow.';
    }
    return responseObj;
}

export const upsertWorkflowConditionAI = async (payload) => {
    let responseObj = { data: null, status: '', message: '', nodeUpdates: [] };
    try {
        let response = await axios({
            method: "POST",
            url: `${AI_BUILDER_API}/api/workflow-conditions/upsert`,
            data: payload,
            headers: {
                tenantId: localStorage.getItem("tenantId"),
            },
        });
        responseObj.status = response.status;
        responseObj.data = response.data?.data ?? null;
        responseObj.message = response.data?.message;
        responseObj.nodeUpdates = Array.isArray(response.data?.nodeUpdates) ? response.data.nodeUpdates : [];
    } catch (error) {
        responseObj.status = error?.response?.status || 500;
        responseObj.message = error?.response?.data?.message || error?.message || 'Failed to generate workflow conditions.';
    }
    return responseObj;
}

export const getSpaceWorkflow = async (spaceId) => {
    let responseObj = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/workflowByField?fieldName=spaceId&value=${spaceId}`,
            headers: {
                tenantId: tenantId
            },
        });

        if (response.status === 200) {
            responseObj.data = response.data?.result?.[0];
            responseObj.status = 200
            response.message = response.data.message || response.message;
        } else {
            responseObj.message = response.data.message || response.message
            responseObj.status = response.status
        }
    }
    catch (error) {
        responseObj.status = 500
        responseObj.message = error?.response?.message
    }
    return responseObj;
}

// The workflow a request sits on, looked up by the request's own `workflowId`.
// The dashboard widgets need it for the step translations their request payloads
// don't carry. `workflowByField` answers with a list; a workflowId matches one.
export const getWorkflowById = async (workflowId) => {
    let responseObj = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/workflowByField?fieldName=workflowId&value=${workflowId}`,
            headers: {
                tenantId: tenantId
            },
        });

        if (response.status === 200) {
            responseObj.data = response.data?.result?.[0];
            responseObj.status = 200
        } else {
            responseObj.message = response.data.message || response.message
            responseObj.status = response.status
        }
    }
    catch (error) {
        responseObj.status = 500
        responseObj.message = error?.response?.message
    }
    return responseObj;
}

export const saveWorkflow = async (postData, update = false) => {
    let responseObj = { data: {}, status: '', message: '' };
    try {
        let response = await axios({
            method: update ? "PUT" : "POST",
            url: `${BACKEND_API}/workflow`,
            data: { ...postData },
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj
}



// FORM SERVICES

export const getFormData = async (formId) => {
    let responseObj = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/form/${formId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj)
        } else {
            responseObj.message = response.data.message
            responseObj.status = response.status
        }
    }
    catch (error) {
        responseObj = errorResponse(error, responseObj)
    }
    return responseObj;
}
export const saveNodeFormData = async (postData) => {
    let responseObj = { data: {}, status: '', message: '' };
    let method = postData.formId ? "PUT" : "POST"
    try {
        let response = await axios({
            method: method,
            url: `${BACKEND_API}/form`,
            data: { ...postData },
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj
}


export const getFormCondition = async (formId) => {
    let responseObj = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/condition/${formId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj)
        } else {
            responseObj.message = response.data.message
            responseObj.status = response.status
        }
    }
    catch (error) {
        responseObj = errorResponse(error, responseObj)
    }
    return responseObj;
}

export const getAllFormConditionForWorkflow = async (workflowId) => {
    let responseObj = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/condition?workflowId=${workflowId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj)
        } else {
            responseObj.message = response.data.message
            responseObj.status = response.status
        }
    }
    catch (error) {
        responseObj = errorResponse(error, responseObj)
    }
    return responseObj;
}

export const getWorkflowConditions = async (workflowId, label = "workflowId") => {
    let responseObj = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/workflow/condition?${label}=${workflowId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj)
        } else {
            responseObj.message = response.data.message
            responseObj.status = response.status
        }
    }
    catch (error) {
        responseObj = errorResponse(error, responseObj)
    }
    return responseObj;
}

export const saveFormCOndition = async (postData) => {
    let responseObj = { data: {}, status: '', message: '' };
    let method = postData.conditionId ? "PUT" : "POST"
    try {
        let response = await axios({
            method: method,
            url: `${BACKEND_API}/condition`,
            data: { ...postData },
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj
}

export const deleteFormCondition = async (conditionId) => {
    let responseObj = { data: {}, status: '', message: '' };
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/condition/${conditionId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj
}

export const getNodeCondition = async (nodeId) => {
    let responseObj = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/workflow/condition?nodeId=${nodeId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj)
        } else {
            responseObj.message = response.data.message
            responseObj.status = response.status
        }
    }
    catch (error) {
        responseObj = errorResponse(error, responseObj)
    }
    return responseObj;
}

export const saveWorkflowCondition = async (postData) => {
    let responseObj = { data: {}, status: '', message: '' };
    let method = postData.conditionId ? "PUT" : "POST"
    try {
        let response = await axios({
            method: method,
            url: `${BACKEND_API}/workflow/condition`,
            data: { ...postData },
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj

}

export const deleteWorkflowCondition = async (conditionId) => {
    let responseObj = { data: {}, status: '', message: '' };
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/workflow/condition/${conditionId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj
}

export const getNotificationIdTemplate = async (notificationId, spaceId) => {
    let responseObj = { data: {}, status: '', message: '' };
    try {
        let response = await axios({
            method: "get",
            url: `${BACKEND_API}/notification/${notificationId}?spaceId=${spaceId}`,
            headers: {
                tenantId: tenantId
            },
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj
}

export const deleteForm = async(formId) => {
    let responseObj = { data: {}, status: '', message: '' };
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/node/${formId}`
        });
        if (response.status === 200) {
            responseObj.data = response.data.result;
        }
        responseObj.status = response.status
        responseObj.message = response.data.message
    }
    catch (error) {

    }
    return responseObj
}